.PinButton {
  background: transparent;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 20px;
  height: 20px;
  cursor: pointer;
  position: absolute;
  right: 6px;
  top: 6px;
  z-index: 10;
  filter: drop-shadow(1px 0 5px rgb(0, 0, 0, .75));

  &.isDisabled {
    path {
      opacity: .5;
    }
  }

  svg {
    width: 15px;
    height: 15px;
  }
}
